<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">护工编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="姓名" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="手机号" required prop="phone">
                                    <el-input v-model="editForm.phone" maxlength="11" placeholder="请输入手机号"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="部门" required prop="departmentCode">
                                    <el-select v-model="editForm.departmentCode" placeholder="请选择部门" style="width:100%">
                                        <el-option
                                                v-for="item in departmentList"
                                                :key="item.departmentCode"
                                                :label="item.name"
                                                :value="item.departmentCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="性别" required prop="gender">
                                    <el-radio-group v-model="editForm.gender" style="width:100%">
                                        <el-radio :label="1">男</el-radio>
                                        <el-radio :label="0">女</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="出生年月" required prop="birthday">
                                    <el-date-picker
                                        v-model="editForm.birthday"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="pickerOption"
                                        style="width:100%"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="用户状态" required prop="status">
                                    <el-select
                                        v-model="editForm.status"
                                        style="width:100%"
                                        placeholder="请选择用户状态">
                                        <el-option
                                            v-for="(item,i) in statusValue"
                                            :key="i"
                                            :label="item"
                                            :value="i">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    export default {
        name: 'Add',
        props:['departmentList'],
        data() {
            return {

                loading: false,
                statusValue:['正常','禁用'],
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    phone:'',
                    departmentCode:'',
                    gender:'',
                    birthday:'',
                    nurseAideCode:'',
                    status:''
                },
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e7;
                    },
                },
                rules:{
                    name:[
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                    departmentCode:[
                        { required: true, message: '请选择部门', trigger: 'blur' },
                    ],
                    gender:[
                        { required: true, message: '请选择性别', trigger: 'blur' },
                    ],
                    birthday:[
                        { required: true, message: '请选择出生年月', trigger: 'blur' },
                    ],
                    phone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号', trigger: 'blur'
                        },
                    ],

                }


            }
        },

        methods: {
            init(row){
                this.loading=false
                // this.editForm.userCode=row.userCode
                this.editForm.status=row.status
                this.editForm.name=row.name
                this.editForm.departmentCode=row.departmentCode
                this.editForm.phone=row.phone
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"User/getUserType",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                        userCode:row.userCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            var data=response.data.data
                            this.editForm.gender=data.gender
                            this.editForm.birthday=data.birthday
                            this.editForm.nurseAideCode=data.nurseAideCode
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            closeSelf() {
                this.$emit("close");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"NurseAide/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("close");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 730px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
